import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { NavigationService } from "../../../shared/services/navigation.service";
import { Subscription } from "rxjs";
import { PerfectScrollbarDirective } from "../perfect-scrollbar";
import { SidenavComponent } from '../sidenav/sidenav.component';

@Component({
  selector: 'app-sidebar-top',
  templateUrl: './sidebar-top.component.html',
  imports: [
    PerfectScrollbarDirective,
    SidenavComponent
  ]
})
export class SidebarTopComponent implements OnInit, OnDestroy, AfterViewInit {
  public menuItems: any[] = [];
  private menuItemsSub: Subscription = new Subscription();
  constructor(
    private navService: NavigationService
  ) { }

  ngOnInit() {
    this.menuItemsSub = this.navService.menuItems$.subscribe(menuItem => {
      this.menuItems = menuItem.filter(item => item.type !== 'icon' && item.type !== 'separator');
    });
  }
  ngAfterViewInit() {

  }
  ngOnDestroy() {
    if (this.menuItemsSub) {
      this.menuItemsSub.unsubscribe()
    }
  }
}
